import Cookies from 'js-cookie'

/**
 * CookieからUTMパラメータを取得
 */
function getUtmParamsFromCookie() {
  const utmKeys = ['utm_source', 'utm_medium', 'utm_term', 'utm_content', 'utm_campaign', 'utm_landing']
  const utmParams = {}

  utmKeys.forEach(key => {
    const value = Cookies.get(key)
    if (value) {
      utmParams[key] = value
    }
  })

  return utmParams
}

/**
 * URLにUTMパラメータを追加
 */
function addUtmParamsToUrl(url, utmParams) {
  if (Object.keys(utmParams).length === 0) {
    return url
  }

  try {
    // 完全なURLまたは相対URLを処理
    const urlObj = new URL(url, window.location.origin)

    // 既存のUTMパラメータは上書きしない
    Object.entries(utmParams).forEach(([key, value]) => {
      if (!urlObj.searchParams.has(key)) {
        urlObj.searchParams.set(key, value)
      }
    })

    // 相対URLの場合は相対形式で返す
    if (url.startsWith('/')) {
      return urlObj.pathname + urlObj.search + urlObj.hash
    }

    return urlObj.toString()
  } catch (e) {
    console.error('Failed to add UTM params to URL:', e)
    return url
  }
}

/**
 * 指定されたセレクタのリンクにUTMパラメータを付与
 */
export default function attachUtmParamsToLinks() {
  const utmParams = getUtmParamsFromCookie()

  // UTMパラメータがない場合は何もしない
  if (Object.keys(utmParams).length === 0) {
    return
  }

  // data-utm-track属性を持つリンクを対象とする
  const links = document.querySelectorAll('a[data-utm-track]')

  links.forEach(link => {
    const originalHref = link.getAttribute('href')
    if (originalHref) {
      const newHref = addUtmParamsToUrl(originalHref, utmParams)
      link.setAttribute('href', newHref)
    }
  })
}

/**
 * 動的に追加されるリンクに対応するためのMutationObserver設定
 */
export function observeAndAttachUtmParams() {
  const utmParams = getUtmParamsFromCookie()

  // UTMパラメータがない場合は監視しない
  if (Object.keys(utmParams).length === 0) {
    return
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) { // Element node
          // 追加されたノード自体がリンクの場合
          if (node.tagName === 'A' && node.hasAttribute('data-utm-track')) {
            const originalHref = node.getAttribute('href')
            if (originalHref) {
              const newHref = addUtmParamsToUrl(originalHref, utmParams)
              node.setAttribute('href', newHref)
            }
          }

          // 追加されたノード内のリンクを探す
          const links = node.querySelectorAll?.('a[data-utm-track]')
          if (links) {
            links.forEach(link => {
              const originalHref = link.getAttribute('href')
              if (originalHref) {
                const newHref = addUtmParamsToUrl(originalHref, utmParams)
                link.setAttribute('href', newHref)
              }
            })
          }
        }
      })
    })
  })

  observer.observe(document.body, {
    childList: true,
    subtree: true
  })
}
